import { reactive } from 'vue';

export const criarEstabelecimento = () => {
  return reactive({
    id: 0,
    idep: 0,
    idsim: 0,
    cdestabelecimento: 0,
    ideprd: 0,
    idatividade: 0,
    idrt: 0,
    nmestabelecimento: '',
    nmfantasia: '',
    endereco: '',
    nmendereco: 0,
    complemento: '',
    bairro: '',
    idmunicipio: 0,
    cep: '',
    fone: '',
    fone2: '',
    fax: '',
    cpfcnpj: '',
    cpfcnpjnros: '',
    ie: '',
    im: '',
    nrosim: '',
    email: '',
    email2: '',
    prop_nome: '',
    prop_cpf: '',
    prop_fone: '',
    nmcontato: '',
    celular_contato: '',
    email_contato: '',
    obs: '',
    ativo: '',
    xstatus: '',
    cdareacomercio: 0,
    nmareacomercio: '',
    cdstsisbi: 0,
    cdstsim: 0,
    cad_sebraetec: '',
    ckdados_moveis: '',
    ckimpressora: '',
    ckinternet: '',
    latitude: 0,
    longitude: 0,
    idlogin: 0
  });
};
